import * as S from './style';

interface Props {
	// eslint-disable-next-line react/require-default-props
	children?: React.ReactNode;
	width: string;
	height: string;
	borderRadius: string;
}

function SkeletonUI({ children, width, height, borderRadius }: Props) {
	return (
		<S.Skeleton width={width} height={height} borderRadius={borderRadius}>
			{children}
		</S.Skeleton>
	);
}

export default SkeletonUI;
